/** Preserves the legacy referral reward title formatting. */
export function capitalizeOnlyFirstLetter(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/common/capitalize.ts